import React from "react";
import { motion } from "framer-motion";

const footerLinks = {
  Services: [
    "Cloud Engineering",
    "Data Engineering",
    "AI & Machine Learning",
    "App Development",
  ],
  Company: ["About Us", "Tech Stack", "Contact Us"],
  Legal: ["Privacy Policy", "Terms of Service", "Cookie Policy", "Contact Us"],
};

const socialIcons = [
  { label: "LinkedIn", icon: "in", href: "#" },
  { label: "Twitter/X", icon: "𝕏", href: "#" },
  { label: "GitHub", icon: "⌥", href: "#" },
];

const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      style={{
        background: "var(--navy2)",
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
      role="contentinfo"
    >
      <div className="max-w-[1200px] mx-auto px-[5%] pt-16 pb-8">
        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div
              className="font-display font-extrabold text-xl tracking-tight gradient-text mb-3"
              style={{ display: "inline-block" }}
            >
              Tekstation
            </div>
            <p
              className="text-sm leading-7 max-w-[280px]"
              style={{ color: "var(--slate)" }}
            >
              Strategic technology consulting for cloud, data, AI, and
              application development. Delivering measurable business outcomes.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([heading, links]) => (
            <div key={heading}>
              <h4
                className="text-xs font-bold uppercase tracking-widest mb-4"
                style={{ color: "var(--steel)" }}
              >
                {heading}
              </h4>
              <ul className="list-none space-y-2">
                {links.map((link) => (
                  <li key={link}>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        if (heading === "Services") scrollTo("#services");
                        else if (link === "About Us") scrollTo("#about");
                        else if (link === "Tech Stack") scrollTo("#stack");
                        else if (link === "Contact Us") scrollTo("#contact");
                      }}
                      className="text-sm transition-colors duration-200"
                      style={{ color: "var(--slate)", textDecoration: "none" }}
                      onMouseEnter={(e) =>
                        (e.target.style.color = "var(--blue2)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.color = "var(--slate)")
                      }
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8"
          style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
          <p className="text-xs" style={{ color: "var(--slate)" }}>
            © {new Date().getFullYear()} Tekstation, Inc. All rights
            reserved.
          </p>
          <div
            className="flex gap-3"
            role="list"
            aria-label="Social media links"
          >
            {socialIcons.map(({ label, icon, href }) => (
              <motion.a
                key={label}
                href={href}
                aria-label={label}
                role="listitem"
                whileHover={{ scale: 1.1 }}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-sm transition-all duration-200"
                style={{
                  background: "rgba(26,107,255,0.1)",
                  border: "1px solid rgba(26,107,255,0.2)",
                  color: "var(--slate)",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(26,107,255,0.2)";
                  e.currentTarget.style.color = "var(--blue2)";
                  e.currentTarget.style.borderColor = "rgba(45,125,255,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(26,107,255,0.1)";
                  e.currentTarget.style.color = "var(--slate)";
                  e.currentTarget.style.borderColor = "rgba(26,107,255,0.2)";
                }}
              >
                {icon}
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
